/*
 *
 * EmbeddedPage constants
 *
 */

export const DEFAULT_ACTION = 'app/EmbeddedPage/DEFAULT_ACTION';
export const UPDATE_SELECTED_CHECKBOX_PRODUCTS =
  'app/EmbeddedPage/UPDATE_SELECTED_CHECKBOX_PRODUCTS';
export const UPDATE_EMBEDDED_OFFER_THEME =
  'app/EmbeddedPage/UPDATE_EMBEDDED_OFFER_THEME';
export const UPDATE_EMBEDDED_MR_OFFER_ID =
  'app/EmbeddedPage/UPDATE_EMBEDDED_MR_OFFER_ID';
export const UPDATE_EMBEDDED_PRIMARY_PRODUCT =
  'app/EmbeddedPage/UPDATE_EMBEDDED_PRIMARY_PRODUCT';
export const UPDATE_PRODUCT_ADD_ONS_WIDGET_ID =
  'app/EmbeddedPage/UPDATE_PRODUCT_ADD_ONS_WIDGET_ID';
export const UPDATE_FIELD = 'app/EmbeddedPage/UPDATE_FIELD';
